import React from "react";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import store from "../stores/reduxStore";
import { Router, Route } from "react-router-dom";
import browserHistory from "../helpers/history";
import { ThemeProvider } from "styled-components";
import { apolloClient } from "js/apollo/apollo-client";

import NounProjectHeader from "../components/nounproject-header";

import { CurrentUserContextProvider } from "contexts/CurrentUserContext";

import theme from "../themes/theme";

import { BannersProvider } from "frontend/context/BannersContext";
import { CookieConsentProvider } from "frontend/context/CookieConsentContext";

const NounProjectHeaderParent = props => {
    return (
        <ThemeProvider theme={theme}>
            <ApolloProvider client={apolloClient}>
                <Provider store={store}>
                    <BannersProvider>
                        <CookieConsentProvider>
                            <CurrentUserContextProvider>
                                <Router history={browserHistory}>
                                    <Route
                                        component={routerProps => (
                                            <NounProjectHeader
                                                {...routerProps}
                                            />
                                        )}
                                    />
                                </Router>
                            </CurrentUserContextProvider>
                        </CookieConsentProvider>
                    </BannersProvider>
                </Provider>
            </ApolloProvider>
        </ThemeProvider>
    );
};

export default NounProjectHeaderParent;
